import { render, staticRenderFns } from "./ListadoPreguntas.vue?vue&type=template&id=59a7012b"
import script from "./ListadoPreguntas.vue?vue&type=script&lang=js"
export * from "./ListadoPreguntas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports